'use client';

import { useScrollFade } from '@/hooks/common/useScrollFade';

import { ScrollFadeProps } from './models';

const VERTICAL_START = 'inset-x-0 top-0 bg-gradient-to-b';
const VERTICAL_END = 'inset-x-0 bottom-0 bg-gradient-to-t';
// RTL: the start edge of a horizontal scroller is on the right.
const HORIZONTAL_START = 'inset-y-0 right-0 bg-gradient-to-l';
const HORIZONTAL_END = 'inset-y-0 left-0 bg-gradient-to-r';

const ScrollFade = ({
    children,
    axis = 'vertical',
    className = '',
    scrollerClassName = '',
    scrollerId,
    fadeClassName = '',
    fadeSizeClassName,
    showStartFade = true,
    enabled = true
}: ScrollFadeProps) => {
    const { scrollerRef, showStart, showEnd } = useScrollFade({ axis, enabled });
    const isVertical = axis === 'vertical';
    const fadeBase = `pointer-events-none absolute z-10 ${fadeSizeClassName ?? (isVertical ? 'h-10' : 'w-10')} from-white via-white/90 to-transparent
        transition-opacity duration-200 ${fadeClassName}`;

    return (
        <div className={`relative ${className}`.trim()}>
            <div ref={scrollerRef} id={scrollerId} className={scrollerClassName}>
                {children}
            </div>
            {enabled && (
                <>
                    {showStartFade && (
                        <div
                            aria-hidden
                            className={`${fadeBase} ${isVertical ? VERTICAL_START : HORIZONTAL_START} ${showStart ? 'opacity-100' : 'opacity-0'}`}
                        />
                    )}
                    <div
                        aria-hidden
                        className={`${fadeBase} ${isVertical ? VERTICAL_END : HORIZONTAL_END} ${showEnd ? 'opacity-100' : 'opacity-0'}`}
                    />
                </>
            )}
        </div>
    );
};

export default ScrollFade;
